var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryRejectedProductsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.24 17.5805H30.84L27.46 14.2005C27.19 13.9305 26.75 13.9305 26.47 14.2005C26.2 14.4705 26.2 14.9105 26.47 15.1905L28.86 17.5805H19.14L21.53 15.1905C21.8 14.9205 21.8 14.4805 21.53 14.2005C21.26 13.9305 20.82 13.9305 20.54 14.2005L17.17 17.5805H16.77C15.87 17.5805 14 17.5805 14 20.1405C14 21.1105 14.2 21.7505 14.62 22.1705C14.86 22.4205 15.15 22.5505 15.46 22.6205C15.75 22.6905 16.06 22.7005 16.36 22.7005H31.64C31.95 22.7005 32.24 22.6805 32.52 22.6205C33.36 22.4205 34 21.8205 34 20.1405C34 17.5805 32.13 17.5805 31.24 17.5805Z",
    fill: "#D92D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 24H16.91C16.29 24 15.82 24.55 15.92 25.16L16.76 30.3C17.04 32.02 17.7899 34 21.1199 34H26.7299C30.0999 34 30.7 32.31 31.0599 30.42L32.07 25.19C32.19 24.57 31.72 24 31.09 24ZM25.92 30.89C25.78 31.04 25.59 31.11 25.39 31.11C25.2 31.11 25.0099 31.04 24.86 30.89L24.02 30.04L23.14 30.92C22.99 31.07 22.7999 31.14 22.6099 31.14C22.4099 31.14 22.2199 31.07 22.0799 30.92C21.7799 30.63 21.7799 30.16 22.0799 29.86L22.9599 28.98L22.1099 28.14C21.8099 27.84 21.8099 27.37 22.1099 27.08C22.3999 26.78 22.8699 26.78 23.17 27.08L24.02 27.92L24.83 27.11C25.13 26.81 25.6 26.81 25.89 27.11C26.19 27.4 26.19 27.87 25.89 28.17L25.08 28.98L25.92 29.83C26.22 30.13 26.22 30.6 25.92 30.89Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryRejectedProductsCardIcon);
export default __webpack_public_path__ + "static/media/inventory-rejected-products-card-icon.6b13113bb9ea053aaa3398d185f8780b.svg";
export { ForwardRef as ReactComponent };